module.exports = __webpack_public_path__ + "static/turtle-creek-house44-a6cfd8ec8bc7878dfc5dd30b8aaa4404.jpg";